import React, { PropsWithChildren } from 'react';

import { FormR } from './style';

const FormRow: React.FC<PropsWithChildren> = ({ children }) => {
  return <FormR>{children}</FormR>;
};

export default FormRow;
